export default __webpack_public_path__ + "87461aec162d12bd0314a5f9d91ad466.png";